// Supabase CRUD for job applications (table: "applications").
// Applicants (anon) can submit + upload resumes; admins read/manage.
import { supabase } from "../supabase/client";

const RESUME_BUCKET = "resumes";

const fromRow = (r) => ({
  id: r.id,
  jobId: r.job_id,
  jobTitle: r.job_title,
  jobDepartment: r.job_department,
  fullName: r.full_name,
  email: r.email,
  phone: r.phone,
  city: r.city,
  matric: r.matric,
  intermediate: r.intermediate,
  degree: r.degree,
  fieldOfStudy: r.field_of_study,
  institution: r.institution,
  graduationYear: r.graduation_year,
  gpa: r.gpa,
  experienceYears: r.experience_years,
  linkedinUrl: r.linkedin_url,
  resumePath: r.resume_path,
  coverNote: r.cover_note,
  status: r.status,
  createdAt: r.created_at,
});

const toRow = (d) => ({
  job_id: d.jobId || null,
  job_title: d.jobTitle,
  job_department: d.jobDepartment,
  full_name: d.fullName,
  email: d.email,
  phone: d.phone,
  city: d.city,
  matric: d.matric,
  intermediate: d.intermediate,
  degree: d.degree,
  field_of_study: d.fieldOfStudy,
  institution: d.institution,
  graduation_year: d.graduationYear,
  gpa: d.gpa,
  experience_years: d.experienceYears,
  linkedin_url: d.linkedinUrl,
  resume_path: d.resumePath,
  cover_note: d.coverNote,
});

// Public: upload a resume to the private bucket, return its storage path.
const slug = (name) => name.replace(/[^a-zA-Z0-9._-]/g, "_");
export async function uploadResume(file) {
  const path = `applications/${Date.now()}-${slug(file.name)}`;
  const { error } = await supabase.storage
    .from(RESUME_BUCKET)
    .upload(path, file, { cacheControl: "3600", upsert: false });
  if (error) throw error;
  return path;
}

// Public: submit an application.
export async function addApplication(data) {
  const { error } = await supabase.from("applications").insert(toRow(data));
  if (error) throw error;
}

// Admin: list all applications (newest first).
export async function getApplications() {
  const { data, error } = await supabase
    .from("applications")
    .select("*")
    .order("created_at", { ascending: false });
  if (error) throw error;
  return data.map(fromRow);
}

export async function updateApplicationStatus(id, status) {
  const { error } = await supabase.from("applications").update({ status }).eq("id", id);
  if (error) throw error;
}

export async function deleteApplication(id) {
  const { error } = await supabase.from("applications").delete().eq("id", id);
  if (error) throw error;
}

// Admin: temporary signed URL to view/download a resume from the private bucket.
export async function getResumeUrl(path) {
  if (!path) return null;
  const { data, error } = await supabase.storage
    .from(RESUME_BUCKET)
    .createSignedUrl(path, 60 * 30); // 30 minutes
  if (error) throw error;
  return data.signedUrl;
}
